import {
  PTM_APPLICATION_TYPES,
  pickLatestApplicationForType,
} from "./prospect/ptmApplicationStatus"

export const SECTION_EMPLOYMENT_VERIFICATION_LABEL = "Waiting on Section"

export const SECTION_EMPLOYMENT_VERIFICATION_MESSAGE =
  "Your application is waiting on your section to verify your employment."

export const REINSTATEMENT_SECTION_EMPLOYMENT_VERIFICATION_MESSAGE =
  "Your reinstatement application is waiting on your section to verify your employment."

// Membership Services has asked for changes, so that status stays in front of
// the section wait. Approved applications are past this step.
const REVIEW_STATUSES = new Set(["submitted", "under_review"])

export const isSectionEmploymentReviewStatus = status =>
  REVIEW_STATUSES.has(String(status || "").toLowerCase())

export const showsSectionEmploymentVerification = (status, awaiting) =>
  awaiting === true && isSectionEmploymentReviewStatus(status)

/**
 * Whether the person's latest Member application is waiting on the section.
 * `awaitingById` comes from useSectionEmploymentVerification; a missing or
 * empty map (flag off, query error) reports false so the submitted copy stays.
 */
export const isLatestMemberApplicationAwaitingSection = (
  memberApplications,
  awaitingById,
) => {
  const latest = pickLatestApplicationForType(
    memberApplications,
    PTM_APPLICATION_TYPES.MEMBER,
  )
  return showsSectionEmploymentVerification(
    latest?.status,
    awaitingById?.get?.(latest?.id) === true,
  )
}
